<div class="container">
  <div class="about-content">
    <h2>About GeM•HD Viewer</h2>
    
    <div class="study-section">
      <h3>GWAS 1-5</h3>
      <p>
        GWAS 1-5 is the summary statistics of a genome-wide association study to identify genetic modifiers of Huntington's disease (HD). 
        This study analyzed approximately 9,000 HD individuals with European ancestry, focusing on age at motor onset. 
        Genetic coordinates of SNPs of GWAS 1-5 are based on GRCh37.
      </p>
    </div>

    <div class="study-section">
      <h3>GWAS 1-6</h3>
      <p>
        GWAS 1-6 is the summary statistics of genome-wide association studies to identify genetic modifiers of Huntington's disease (HD). 
        This study analyzed approximately 12,000 HD individuals, focusing on identifying modifiers of:
      </p>
      <ul>
        <li>Blood instability phenotypes</li>
        <li>Clinical phenotypes (DCL4, onset, and TFC6)</li>
        <li>Algorithmically predicted quantile phenotypes (bradykinesia, chorea, dystonia, oculomotor, rigidity, SDMT, stroop word, and TMS)</li>
      </ul>
      <p>
        Genetic coordinates of SNPs of GWAS 1-6 are based on GRCh38.
      </p>
    </div>

    <div class="study-section">
      <h3>Enroll-HD WGS+</h3>
      <p>
        Enroll-HD WGS+ is the GWAS meta-analysis summary statistics to identify genetic modifiers of Huntington's disease (HD).
        This study analyzed approximately 18,000 individuals with CAG length greater than 35 including 14K individuals with events,
        focusing on identifying modifiers of:
      </p>
      <ul>
        <li>HD symptom onset (symptoms include motor, cognitive, and psychiatric symptoms captured by Clinical Characteristics Questionnaire)</li>
        <li>Age at HD diagnosis (by 4 ascertainment methods, hddiagn, sxrater, sxfam, and sxsubj)</li>
      </ul>
      <p>
        The non-overlapping cohorts included in the meta-analysis include 1) Enroll-HD participants previously genotyped by microarray;
        2) new Enroll-HD participants with WGS data; 3) Legacy REGISTRY participants previously genotyped by microarray and did not
        roll over to Enroll-HD.
      </p>
      <p>
        Genetic coordinates of SNPs of WGS+ are based on GRCh38.
      </p>
    </div>
  </div>
</div>